<template>
  <div class="phone-app">
    <el-loading fullscreen="true" :style="{ display: isLoad ? 'block' : 'none' }" text="加载中..."></el-loading>
    <div class="header">
      <h1>水电管理</h1>
    </div>
    <div class="content">
      <div v-for="item in data" :key="item.id" class="item-card" @click="isTiao(item)">
        <div v-if="item.url_name !== '新增'" class="item-icon-wrapper">
          <div v-if="!item.image || item.image.startsWith('el-icon')" class="avatar-text-phone">{{ getAvatarText(item.url_name) }}</div>
          <img v-else :src="item.image" class="item-icon" @error="imageError(item)" alt="">
        </div>
        <i v-else class="el-icon-plus item-icon-add"></i>
        <span class="item-name">{{ item.url_name }}</span>
        <i v-if="item.list && item.list.length > 0" class="el-icon-arrow-right" style="font-weight: bold; color: #909399; margin-right: 10px;"></i>
        <div class="item-actions" v-if="item.url_name !== '新增'">
          <el-button-group>
            <el-button type="primary" icon="el-icon-plus" size="mini" @click.stop="addChild(item.id)"></el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click.stop="edit(item)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click.stop="del(item)"></el-button>
          </el-button-group>
        </div>
      </div>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisible3" :fullscreen="true" :close-on-click-modal="false" @close="Clear">
      <el-form :model="form" label-position="top">
        <el-form-item label="名称">
          <el-input v-model="form.url_name"></el-input>
        </el-form-item>
        <el-form-item label="跳转网址">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item label="同级排序">
          <el-input v-model="form.px"></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <div>
            <input type="file" ref="fileInput" style="display: none" accept="image/*" @change="handleImageUpload" />
            <el-button @click="$refs.fileInput.click()">选择图片</el-button>
            <img v-if="form.image" style="width: 100px; margin-top: 10px;" :src="form.image" alt="上传图标" />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="Tijiao">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="图片裁剪" :visible.sync="cropperDialogVisible" :fullscreen="true">
      <div style="height: 80vh;">
        <vue-cropper
          ref="cropper"
          :img="cropperImg"
          :auto-crop="true"
          :fixed-box="true"
          :fixed="true"
          :fixed-number="[1, 1]"
          :center-box="true"
          output-type="png"
        ></vue-cropper>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cropperDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getCroppedImage">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showChildren" :fullscreen="true" :title="currentTitle">
      <div class="content">
        <div v-for="item in childrenData" :key="item.id" class="item-card" @click="isTiao(item)">
          <div class="item-icon-wrapper">
            <div v-if="!item.image || item.image.startsWith('el-icon')" class="avatar-text-phone">{{ getAvatarText(item.url_name) }}</div>
            <img v-else :src="item.image" class="item-icon" @error="imageError(item)" alt="">
          </div>
          <span class="item-name">{{ item.url_name }}</span>
          <i v-if="item.list && item.list.length > 0" class="el-icon-arrow-right" style="font-weight: bold; color: #909399; margin-right: 10px;"></i>
           <div class="item-actions">
            <el-button-group>
              <el-button type="primary" icon="el-icon-edit" size="mini" @click.stop="edit(item)"></el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click.stop="del(item)"></el-button>
            </el-button-group>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Phone',
  computed: {
    getAvatarText() {
      return (name) => {
        if (!name) return '';
        if (name.length > 2) {
          return name.substring(0, 2);
        }
        return name;
      };
    }
  },
  data() {
    return {
      api_url: '/api',
      dataLoaded: false,
      data: [],
      dialogVisible3: false,
      title: '新增',
      pid: 0,
      id: 0,
      form: {
        url_name: '',
        url: '',
        image: '',
        px: '',
      },
      childrenData: [],
      isLoad: false,
      refushChild: false,
      showChildren: false,
      cropperDialogVisible: false,
      cropperImg: '',
      currentTitle: '下级菜单'
    }
  },
  mounted() {
    if (!this.dataLoaded) {
      this.get_data();
    }
  },
  methods: {
    async get_data() {
      this.isLoad = true;
      try {
        const response = await this.$http.get(`${this.api_url}/kbgl/get_myurl`);
        const res = response.data;
        res.DATA.push({
          id: -1,
          url: '',
          image: 'el-icon-plus',
          pid: 0,
          url_name: '新增',
          px: 999999
        });
        if (this.refushChild) {
          let tmpData = res.DATA.find(it => it.id === this.pid);
          this.childrenData = tmpData.list;
        }
        this.data = res.DATA;
      } catch (err) {
        this.$message({
          type: 'error',
          message: err.response ? err.response.data.RTN_MSG : '网络错误',
          duration: 3000,
        });
      } finally {
        this.isLoad = false;
      }
    },
    isTiao(item) {
      if (item.url_name === '新增') {
        this.dialogVisible3 = true;
        this.title = '新增';
        this.pid = 0;
      } else if (!item.list || item.list.length === 0) {
        window.open(item.url, '_blank');
      } else {
        this.childrenData = item.list;
        this.currentTitle = item.url_name;
        this.showChildren = true;
      }
    },
    Clear() {
      this.form = {
        url_name: '',
        url: '',
        image: '',
        px: ''
      };
    },
    async Tijiao() {
      this.isLoad = true;
      const data = { ...this.form, pid: this.pid };
      try {
        let url = `${this.api_url}/kbgl/add_myurl`;
        if (this.title === '编辑' || this.title === '新增下级') {
          data.id = this.id;
          url = `${this.api_url}/kbgl/up_myurl`;
        }
        const response = await this.$http.post(url, data);
        const res = response.data;
        if (res.RTN_CODE === '200') {
          this.$message({ type: 'success', message: res.RTN_MSG });
          this.dialogVisible3 = false;
          this.refushChild = this.pid !== 0;
          this.get_data();
          this.Clear();
        } else {
          this.$message({ type: 'error', message: res.RTN_MSG });
        }
      } catch (err) {
        this.$message({ type: 'error', message: err.response ? err.response.data.RTN_MSG : '操作失败' });
      } finally {
        this.isLoad = false;
      }
    },
    findItemById(data, id) {
      for (let item of data) {
        if (item.id === id) {
          this.form = { ...item };
          return item;
        }
        if (item.list && item.list.length > 0) {
          let found = this.findItemById(item.list, id);
          if (found) return found;
        }
      }
    },
    addChild(id) {
      this.dialogVisible3 = true;
      this.title = '新增下级';
      this.pid = id;
      this.id = 0; // Reset id for new child
      this.Clear();
    },
    edit(item) {
      this.findItemById(this.data, item.id);
      this.dialogVisible3 = true;
      this.title = '编辑';
      this.pid = item.pid;
      this.id = item.id;
    },
    del(item) {
      this.$confirm(`确定删除 "${item.url_name}"?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.isLoad = true;
        try {
          await this.$http.post(`${this.api_url}/kbgl/del_myurl`, { id: item.id });
          this.$message({ type: 'success', message: '删除成功!' });
          this.showChildren = false;
          this.get_data();
        } catch (err) {
          this.$message({ type: 'error', message: err.response ? err.response.data.RTN_MSG : '删除失败' });
        } finally {
          this.isLoad = false;
        }
      }).catch(() => {});
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.cropperImg = e.target.result;
          this.cropperDialogVisible = true;
        };
        reader.readAsDataURL(file);
      }
    },
    getCroppedImage() {
      this.$refs.cropper.getCropData(data => {
        this.form.image = data;
        this.cropperDialogVisible = false;
      });
    },
    imageError(item) {
      this.$set(item, 'image', 'el-icon-picture-outline');
    }
  }
}
</script>

<style scoped>
.phone-app {
  background-color: #f4f4f5;
  min-height: 100vh;
  color: #303133;
}
.header {
  background-color: #409EFF;
  color: white;
  padding: 15px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 10;
}
.header h1 {
  margin: 0;
  font-size: 20px;
}
.content {
  padding: 10px;
}
.item-card {
  background: white;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 15px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s;
}
.item-card:active {
    transform: scale(0.98);
}
.item-icon {
  width: 80%;
  height: 80%;
  border-radius: 50%;
  /* margin-right: 15px; */
}
.item-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 6px #3a3a3a;
  /* background-color: #409EFF; */
  color: #409EFF;
}
.avatar-text-phone {
  font-size: 14px;
}
.item-icon-add {
    font-size: 40px;
    color: #409EFF;
    margin-right: 15px;
}
.item-name {
  flex-grow: 1;
  font-size: 16px;
  font-weight: 500;
}
.item-actions .el-button {
  margin-left: 5px;
}
</style>